import React from 'react';
import animeImage from '../assets/anime.png';
import '../App.css';

const AboutUs = () => {
  return (
    <div style={{ padding: '20px', backgroundColor: '#FFFFFF', minHeight: '100vh', textAlign: 'center' }}>
      <h1
        style={{
          fontFamily: "'Dancing Script', cursive",
          fontSize: '48px',
          fontWeight: 'bold',
          color: '#2D3E50',
          marginBottom: '20px',
        }}
      >
        See it before you live it
      </h1>
      
      <div style={{ marginBottom: '30px' }}>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/K0aTIdy7Qs4"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{
            maxWidth: '100%',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}
        ></iframe>
      </div>

      <p
        style={{
          fontSize: '18px',
          color: '#666',
          marginTop: '20px',
          marginBottom: '20px',
          lineHeight: '1.5',
        }}
      >
        Renovating home is tiresome. We will make it lot more easier. Try before you buy. Virtually.
      </p>
      <p style={{ fontSize: '16px', color: '#2D3E50', marginBottom: '10px' }}>
        Founders:
        <span style={{ marginLeft: '5px' }}>
          Giorgi Mekvabishvili 🏴‍☠️
          <a
            href="https://x.com/g_mekv"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: '5px', color: '#4A90E2', textDecoration: 'underline' }}
          >
            @g_mekv
          </a>
        </span>
        <span style={{ marginLeft: '10px' }}>
          Nika Pavliashvili
          <a
            href="https://www.linkedin.com/in/nika-pavliashvili-b236641b5/?originalSubdomain=ge"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: '5px', color: '#4A90E2', textDecoration: 'underline' }}
          >
            LinkedIn
          </a>
        </span>
      </p>
    </div>
  );
};

export default AboutUs;